import * as React from "react";
import { cn } from "@/utils";
import { Button } from "./button";
import { Card } from "@/components/ui/card";

export interface ToastAction {
    label: string;
    onClick: () => void;
}

export interface ToastProps {
    visible: boolean;
    message: string;
    action?: ToastAction;
    className?: string;
}

const Toast = React.forwardRef<HTMLDivElement, ToastProps>(
    ({ visible, message, action, className }, ref) => {
        if (!visible) return null;

        return (
            <Card
                ref={ref}
                className={cn(
                    "tw:fixed tw:bottom-4 tw:right-4 tw:z-max tw:max-w-md tw:p-4 tw:shadow-lg tw:animate-in tw:slide-in-from-bottom-2",
                    className,
                )}
            >
                <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
                    <p className="tw:text-sm tw:flex-1">{message}</p>
                    {action && (
                        <Button className="btn btn-primary" onClick={action.onClick}>
                            {action.label}
                        </Button>
                    )}
                </div>
            </Card>
        );
    },
);
Toast.displayName = "Toast";

export { Toast };
